import { connect } from 'react-redux';
import { getRedirectInfoRequest } from './direct-routes-handler-actions';
import DirectRoutesHandler from '../components/direct-routes-handler';
// eslint-disable-next-line
import setActiveServiceCenter from '../../header/service-center-toggle/containers/service-center-toggle-actions'

const mapStateToProps = state => ({
  redirectInfo: state.direct.redirectInfo,
  isLoading: state.direct.isLoading,
  error: state.direct.error,
  activeServiceCenter: state.serviceCenter.activeServiceCenter,
});

const mapDispatchToProps = { getRedirectInfoRequest, setActiveServiceCenter };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DirectRoutesHandler);
